import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7ee71fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container mt-4"
}
const _hoisted_2 = { class: "border rounded-5" }
const _hoisted_3 = { class: "row mt-3 mb-1 px-3" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"width":"98%","margin":"6px auto"} }, null, -1))
const _hoisted_6 = { class: "row mt-4 mb-2 mx-1" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-calendar calender-green",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_9 = { class: "col text-end" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-calendar calender-red",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-body pt-0" }
const _hoisted_13 = { class: "my-5" }
const _hoisted_14 = { class: "svg-icon svg-icon-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fw-bolder text-gray-800 text-hover-primary fs-6"
  }, "Funding Required")
], -1))
const _hoisted_16 = { class: "svg-icon svg-icon-1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fw-bolder text-gray-800 text-hover-primary fs-6"
  }, "Pre-Money Valuation")
], -1))
const _hoisted_18 = { class: "svg-icon svg-icon-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "fw-bolder text-gray-800 text-hover-primary fs-6"
  }, "Minimum Investment")
], -1))
const _hoisted_20 = { class: "row mt-4 mb-3 pr-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_22 = { class: "col text-end" }
const _hoisted_23 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_24 = { class: "card-body p-9" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row my-3" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Investment History")
], -1))
const _hoisted_26 = { class: "row mb-7" }
const _hoisted_27 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_28 = {
  key: 0,
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_29 = { class: "card-body p-9" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row my-3" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Investment Secured On This Round")
], -1))
const _hoisted_31 = { class: "row mb-7" }
const _hoisted_32 = { class: "col-md-12" }
const _hoisted_33 = { class: "fv-row mb-10" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Investor", -1))
const _hoisted_35 = ["value"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Other", -1))
const _hoisted_37 = { class: "fv-row mb-10" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Add Investment", -1))
const _hoisted_39 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_40 = ["data-kt-indicator"]
const _hoisted_41 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_42 = { class: "indicator-progress" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_44 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_InvestmentHistory = _resolveComponent("InvestmentHistory")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.fundingRoundExists)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("strong", null, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.fundingRound.name), 1)
                ])
              ])
            ]),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", null, [
                  _hoisted_8,
                  _createTextVNode(" Opens " + _toDisplayString(_ctx.formatDate(_ctx.fundingRound.opensAt)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", null, [
                  _hoisted_10,
                  _createTextVNode(" closes " + _toDisplayString(_ctx.formatDate(_ctx.fundingRound.closesAt)), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass([['mb-7', `bg-light-info`], "d-flex align-items-center rounded p-5 mb-7"])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass([`svg-icon-info`, "svg-icon me-5"])
                    }, [
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
                      ])
                    ]),
                    _hoisted_15,
                    _createElementVNode("span", {
                      class: _normalizeClass([`text-info`, "fw-bolder py-1"])
                    }, _toDisplayString(_ctx.formatter(
                    _ctx.fundingRound.investment_required,
                    _ctx.currencyCodeEnums[_ctx.op.get(_ctx.business, "currencyCode", "pound")]
                  )), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass([['mb-7', `bg-light-info`], "d-flex align-items-center rounded p-5 mb-7"])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass([`svg-icon-info`, "svg-icon me-5"])
                    }, [
                      _createElementVNode("span", _hoisted_16, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
                      ])
                    ]),
                    _hoisted_17,
                    _createElementVNode("span", {
                      class: _normalizeClass([`text-info`, "fw-bolder py-1"])
                    }, _toDisplayString(_ctx.formatter(
                    _ctx.fundingRound.preMoneyValuation,
                    _ctx.currencyCodeEnums[_ctx.op.get(_ctx.business, "currencyCode", "pound")]
                  )), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    class: _normalizeClass([['mb-7', `bg-light-info`], "d-flex align-items-center rounded p-5 mb-7"])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass([`svg-icon-info`, "svg-icon me-5"])
                    }, [
                      _createElementVNode("span", _hoisted_18, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
                      ])
                    ]),
                    _hoisted_19,
                    _createElementVNode("span", {
                      class: _normalizeClass([`text-info`, "fw-bolder py-1"])
                    }, _toDisplayString(_ctx.formatter(
                    _ctx.fundingRound.minimumInvestment,
                    _ctx.currencyCodeEnums[_ctx.op.get(_ctx.business, "currencyCode", "pound")]
                  )), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("span", {
                  style: _normalizeStyle(
                _ctx.fundingRound?.status == 1
                  ? 'background-color: green; color: white'
                  : _ctx.fundingRound?.status == 2
                  ? 'background-color: red; color: white'
                  : ''
              ),
                  class: "text-royalblue py-1 px-2 rounded-5 font-weight-bold"
                }, _toDisplayString(_ctx.fundingRound?.status == 0
                  ? "Awaiting Approval"
                  : _ctx.fundingRound?.status == 1
                  ? "Approved"
                  : "Rejected"), 5)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                (_ctx.fundingRound?.fundingRoundInvestments?.length ?? false)
                  ? (_openBlock(), _createBlock(_component_InvestmentHistory, {
                      key: 0,
                      investments: _ctx.fundingRound?.fundingRoundInvestments ?? [],
                      currencyCode: 
                _ctx.currencyCodeSymbolEnums[_ctx.business?.currencyCode ?? 'pound']
              
                    }, null, 8, ["investments", "currencyCode"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, "No Entries"))
              ])
            ])
          ]),
          (_ctx.fundingRound?.status == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("form", {
                    onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createInvestment && _ctx.createInvestment(...args)))
                  }, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.investorId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.investorId) = $event)),
                            name: "investor",
                            class: "form-select form-select-lg form-select-solid",
                            "data-control": "select2",
                            "data-placeholder": "Select...",
                            "data-allow-clear": "true",
                            "data-hide-search": "true",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.investors, (investor) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: investor.id,
                                  value: investor.id
                                }, _toDisplayString(investor?.user?.firstName) + " " + _toDisplayString(investor?.user?.lastName), 9, _hoisted_35))
                              }), 128)),
                              _hoisted_36
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "investor",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _hoisted_38,
                          _createVNode(_component_el_input, {
                            name: "amount",
                            modelValue: _ctx.investmentAmount,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.investmentAmount) = $event)),
                            placeholder: "0.00"
                          }, {
                            prepend: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.currencyCodeSymbolEnums[
                        _ctx.op.get(_ctx.business, "currencyCode", "pound")
                      ]), 1)
                            ]),
                            append: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.currencyCodeEnums[
                        _ctx.op.get(_ctx.business, "currencyCode", "pound")
                      ]), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          (!_ctx.investmentAmount && _ctx.touched)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_39, " Amount is required! "))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("button", {
                      "data-kt-indicator": _ctx.loading ? 'on' : null,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.touch && _ctx.touch(...args))),
                      class: "btn btn-primary float-end"
                    }, [
                      (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, "Save"))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_42, [
                        _hoisted_43,
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_44))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_40)
                  ], 32)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}